import { render } from "./FullChapterListPage.vue?vue&type=template&id=1847d055&scoped=true"
import script from "./FullChapterListPage.vue?vue&type=script&lang=js"
export * from "./FullChapterListPage.vue?vue&type=script&lang=js"

import "./FullChapterListPage.vue?vue&type=style&index=0&id=1847d055&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1847d055"]])

export default __exports__